import { useRef, useState } from "react";
import { Loader2, Upload } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../ui/button";

/** Import multiple de packages SCORM → séquences d'un module de cours (nouveau ou existant). */
export async function importScormSequences(api, files, { title = "", lessonId = "", programId = "", onProgress } = {}) {
  const fd = new FormData();
  Array.from(files).forEach((f) => fd.append("files", f));
  if (title) fd.append("title", title);
  if (lessonId) fd.append("lesson_id", lessonId);
  if (programId) fd.append("program_id", programId);
  const r = await api.post("/lms/lessons/scorm-import", fd, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (ev) => onProgress?.(Math.round((ev.loaded / (ev.total || 1)) * 100)),
  });
  return r.data;
}

export function ScormMultiImportButton({ api, lessonId, onDone, className = "", label = "Importer des SCORM", testId = "scorm-multi-import" }) {
  const ref = useRef(null);
  const [prog, setProg] = useState(null);
  return (
    <>
      <input ref={ref} type="file" multiple accept=".zip,application/zip" className="hidden" data-testid={`${testId}-input`} onChange={async (e) => {
        const files = e.target.files;
        if (!files?.length) return;
        setProg(0);
        try {
          const d = await importScormSequences(api, files, { lessonId, onProgress: setProg });
          toast.success(`${d.imported} séquence${d.imported > 1 ? "s" : ""} SCORM importée${d.imported > 1 ? "s" : ""}`);
          onDone?.(d);
        } catch (ex) { toast.error(ex.response?.data?.detail || ex.message); }
        setProg(null);
        e.target.value = "";
      }} />
      <Button onClick={() => ref.current?.click()} disabled={prog !== null} variant="outline" className={"border-sky-500/40 text-sky-300 hover:bg-sky-500/10 font-bold " + className} data-testid={`${testId}-btn`}>
        {prog !== null ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Upload className="w-4 h-4 mr-2" />}
        {prog !== null ? `Import ${prog}%` : label}
      </Button>
    </>
  );
}
